import Noty from 'noty';
import '../../styles/notification.scss';
import iconSuccess from '../../icons/succes.svg';
import iconError from '../../icons/error.svg';
import iconInfo from '../../icons/info.svg';
import iconClose from '../../icons/close.svg';

const Notification = (props) => {
  Noty.overrideDefaults({
    timeout: 10000,
    callbacks: {
      onTemplate: function() {
        let notificationIconType;

        switch (this.options.type) {
          case 'success':
            notificationIconType = iconSuccess;
            break;
          case 'error':
            notificationIconType = iconError;
            break;
          default:
            notificationIconType = iconInfo;
        }

        this.barDom.innerHTML = '<div class="noty_body">';
        this.barDom.innerHTML += '<div class="type-icon-container"><img src="' + notificationIconType + '" /></div>';
        this.barDom.innerHTML += '<div class="text-container"><span class="notification-text">' + this.options.text + '</span></div>';
        this.barDom.innerHTML += '<div class="close-icon-container"><span class="close-icon"><img src="' + iconClose + '" /></span></div>';
        this.barDom.innerHTML += '</div>';
      }
    }
  });

  return new Noty({
    ...props
  });
};

export default Notification;
